import { CreateAdvanceRow } from '@willow/types-iso';

import { makeValidator } from '../../shared/makeValidator';

export const validateCreateAdvance = makeValidator({
  FieldParser: CreateAdvanceRow,
});
